import React from "react";

const ValidacionExitosa: React.FC = () => {

  return (
    <div className="flex flex-col items-center pt-10">
      <h1 className="text-3xl font-bold text-center pt-10">Validación Exitosa</h1>
      <p className="text-base text-center pt-5">
        ¡Tu identidad ha sido validada correctamente!
      </p>
      <p className="text-base text-center pt-3 text-gray-600">
        Por favor, comunícate con tu asesor para continuar con el proceso.
      </p>
    </div>
  );
};

export default ValidacionExitosa;